import {apiClient, FetcherSettings} from './apiClient';

type FeedbackPayload = {
  reservation: string;
  rating?: number;
  comment?: string;
};

type CreateFeedbackPayload = FeedbackPayload & {
  was_closed?: boolean;
};

class FeedbackApi {
  ENDPOINTS = {
    createFeedback: () => 'api/v3/feedbacks/',
    checkoutFeedback: () => 'api/v3/reservation-check-out-feedbacks/',
  };

  async createFeedback(
    payload: CreateFeedbackPayload,
    fetcherSettings?: FetcherSettings,
  ) {
    const response = await apiClient.post(this.ENDPOINTS.createFeedback(), {
      json: payload,
      ...fetcherSettings,
    });
    return response.body;
  }

  async createCheckoutFeedback(
    payload: FeedbackPayload,
    fetcherSettings?: FetcherSettings,
  ) {
    const response = await apiClient.post<FeedbackPayload>(
      this.ENDPOINTS.checkoutFeedback(),
      {
        json: payload,
        ...fetcherSettings,
      },
    );
    return response.body;
  }
}

export {FeedbackApi};
export type {CreateFeedbackPayload, FeedbackPayload};
